<template>
<div class="action-table">
    <v-client-table
        :data="tableData"
        :columns="columns"
        :options="options"
        ref="table"
    >
        <colored-letter-square slot="cls_column"
            slot-scope="props"
            :name="props.row.full_name"
            :length="2"
            :color="setColorOfColoredLetterSquare(props.row.roles[0].title)"
        >
        </colored-letter-square>

        <div slot="actions"
            slot-scope="props"
        >
            <ManagerTableActions
                :data="props.row"
                :index="props.index"
            ></ManagerTableActions>
        </div>
    </v-client-table>
</div>
</template>

<script>
import { EventBus } from '../eventbus';
import { Event } from 'vue-tables-2';

export default {
    props: [],

    components: {},

    data() {
        return {
            database_ident_input: null,
            search_input: null,
            tableData: [],
            show_deleted_users: false,
            // this value will be changed after a successful ajax call,
            // so that the action button won't be changed before users successfully loaded.
            change_action: false,
            isAdmin: false,
            columns: ['cls_column', 'full_name', 'role_trans', 'actions'],

            options: {
                headings: {
                    cls_column: '',
                    full_name: this.trans('managers.label.full_name'),
                    role_trans: this.trans('managers.label.role'),
                    actions: this.trans('vuetables.label.actions')
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['full_name'],
            }
        };
    },

    created() {
        this.fetch(this.show_deleted_users);
    },

    methods: {
        fetch(showDeletedUsers) {
            // set back to current_url, after unselecting the checkbox
            var url;
            if (showDeletedUsers) {
                url = this.route('mainapi.managers.index.deleted');
                EventBus.$emit('onChangeAction', showDeletedUsers);
            } else {
                url = this.route('mainapi.managers.index');
            }
            axios.get(url).then(this.refresh);
        },

        refresh({ data }) {
            // clear all search_input
            this.search_input = null;

            // fetch the data
            this.tableData = data.data;

            // fetch all databse and client name and is_admin values if exist, or just keep the old
            this.isAdmin = data.is_admin ? data.is_admin: this.isAdmin;

            // change the change_action, so that the action button can be changed
            this.change_action = this.show_deleted_users ? true : false;

            // scroll to the top
            window.scrollTo(0, 0);

            EventBus.$emit('filterDataChanged', {isAdmin: this.isAdmin });

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },

        search() {
            Event.$emit('vue-tables.filter::alphabet', this.search_input);
            this.setSessionData();
        },

        /**
         * Displays modal with two options: Reset password and welcome mail
         */
        resetPassword(row) {
            this.$modal.show(
                {
                    template: `
                    <reset-password :user="user" @close="$emit('close')"></reset-password>
                `,
                    props: ['user']
                },
                {
                    user: row.id
                },
                {
                    height: 'auto',
                    adaptive: true,
                    pivotY: 0.3
                },
                {}
            );
        },

        /**
         * Displays modal with two options: Reset password and welcome mail
         */
        toggleStatus(row, index) {
            this.$alertify.confirmWithTitle(
                row.is_active ? this.trans('managers.note.deactivate_user') : this.trans('managers.note.activate_user'),
                row.is_active ? this.trans('managers.note.deactivate_message') : this.trans('managers.note.activate_message'),
                () => {
                axios
                    .get(this.route('mainapi.managers.status.toggle', row.id))
                    .then(response => {
                        if (response.data.success) {
                            this.tableData[index].is_active = !this.tableData[index].is_active;
                        }
                        this.flash(response);
                    })
                    .catch((error) => {
                        this.flash({message: this.trans('managers.flash.not_executed'), level: 'warning'});
                    });
                }
            );
        },

        /**
         * Deletes the given user
         */
        delete(row, index) {
            this.$alertify.confirmWithTitle(
                this.trans('managers.note.delete_title'),
                this.trans('managers.note.delete_message'),
                () => {
                    axios
                        .delete(this.route('mainapi.managers.destroy', row.id))
                        .then(response => {
                            if (response.data.success == true) {
                                this.tableData = response.data.data;
                            }
                            this.flash(response);
                        })
                        .catch(error => {
                            this.flash({
                                message: this.trans('managers.flash.not_deleted'),
                                level: 'warning'
                            });
                        });
                }
            );
        },

        restoreUser(row, index) {
            this.$alertify.confirmWithTitle(
                this.trans('managers.note.restore_user'),
                this.trans('managers.note.restore_message'),
                () => {
                axios
                    .get(this.route('mainapi.managers.restore', row.id))
                    .then(response => {
                        this.tableData.splice(index - 1, 1);
                        this.flash(response);
                    })
                    .catch((error) => {
                        this.flash({message: this.trans('managers.flash.not_executed'), level: 'warning'});
                    });
                }
            );
        },

        setColorOfColoredLetterSquare(role) {
            switch (role) {
                case "admin":
                    return '#79bc52';
                case "accounting":
                    return '#f8cc99';
                case "editor":
                    return '#d65c5c';
                case "support":
                    return '#e899ca';
            }
        }
    },

    mounted() {
        EventBus.$on('onDelete', (deleteId) => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('filterDeletedUser', show => {
            this.fetch(show);
        });

        EventBus.$on('onRestoreUser', index => this.tableData.splice(index, 1));
    }
};
</script>
